// AUTO-GENERATED by scripts/convert-locators.js — do not edit by hand.
// Source: /home/abhiram/Desktop/sample_los/appium-tests/src/test/java/com/sample/los/locators
import s0 from './AddLead.json';
import s1 from './Consents.json';
import s2 from './Contacts.json';
import s3 from './LeadDetail.json';
import s4 from './Leads.json';
import s5 from './Login.json';
import s6 from './Onboarding.json';
import s7 from './Register.json';

export const MOBILE_LOCATOR_SCREENS = [s0, s1, s2, s3, s4, s5, s6, s7];

export const findScreen = (name) =>
  MOBILE_LOCATOR_SCREENS.find(
    (s) => s.screen.toLowerCase() === String(name || '').toLowerCase()
  ) || null;

export default MOBILE_LOCATOR_SCREENS;
